import React, { useEffect, useState } from "react";
import ProjectDetails from "../components/ProjectDetails/ProjectDetails";
import { vendorApi, api } from "../api/api";
import { render } from "@testing-library/react";
import ProjectPlotStructure from "../components/ProjectDetails/ProjectPlotStructure";
import ProjectImages from "../components/ProjectDetails/ProjectImages";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import CryptoJS from "crypto-js";
import { updateReferrerId } from "../redux/reducers/Reducer";
import { useDispatch } from "react-redux";
import ProjectDocument from "../components/ProjectDetails/ProjectDocument";
import ProjectLayoutPage from "../components/ProjectDetails/ProjectLayoutPage";
import RecentPropertiesList from "../components/RecentProperties/RecentPropertiesList";
import Loader from "../components/common/Loader";
import LoginModal from "../components/common/LoginModal";
import ScreenContainer from "../components/common/screencontainer";
import Description from "../components/common/Description";
import { useParams, useLocation } from "react-router-dom";
 
 
const SECRET_KEY = "yourSecretKey";
 
const ProjectDetailsScreen = () => {
  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const location = useLocation();
  const query = decodeURIComponent(location.search.slice(1));
const [searchParams] = useSearchParams();
  const { slug } = useParams();
const projectId = slug?.split("-").pop();
const referralCode = searchParams.get("ref");

  
 
  let property_code = null;
  let reffer_code = null;
 
  if (query) {
    const parts = query.split('/');
    if (parts.length === 2) {
      property_code = parts[0];
      reffer_code = parts[1];
    } else if (parts.length === 1) {
      property_code = parts[0];
    }
  }
 
  const theme = useSelector((data) => data.themeValue.colors);
  // const { projectId } = location.state || {};
  // const [searchParams] = useSearchParams();
  const { type, data } = location.state || {};
 
  const encryptedPropertyId = searchParams.get('projectId');
  const encryptedUserId = searchParams.get('userId');
 
  const decryptData = (ciphertext) => {
    try {
      const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (error) {
      console.error('Decryption failed:', error);
      return null;
    }
  };
 
  const propertyId = encryptedPropertyId ? decryptData(encryptedPropertyId) : null;
  const ReffererId = encryptedUserId ? decryptData(encryptedUserId) : null;
 
 
 
  const navigate = useNavigate();
 
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
 
 
 
  const dispatch = useDispatch();
  
  useEffect(() => {
    const runEffect = async () => {
      try {
 
 
//         const { data } = await api.getProjectId(
//           property_code || null,
//           reffer_code || null
//         );
//         const projectId = data.propertyId;
//         const ReffererId = data.userId;
 
//         window.scrollTo({ top: 0, behavior: "smooth" });
 
//         if (!projectId) return;
 
//         if (ReffererId) {
//           dispatch(updateReferrerId({ ReffererId }));
//         }
 
//         // Step 2: Add project-user mapping
//         const fd = new FormData();
//         fd.append("userId", userId);
//         fd.append("refererId", ReffererId);
//         fd.append("projectId", projectId);
 
//         if (
//   isAuthenticated &&
//   userId &&
//   projectId &&
//   ReffererId &&
//   userId !== parseInt(ReffererId)
// ) {
//   const fd = new FormData();
//   fd.append("userId", userId);
//   fd.append("refererId", ReffererId);
//   fd.append("projectId", projectId);

//   await vendorApi.addProjectUserMapping(fd);
// }

 
        // Step 3: Fetch project details
        try {
          const response = await vendorApi.getProjectById(projectId);
          if (response.status === 200) {
            setProjectData(response.data);
          }
        } catch (error) {
          console.error("API Error:", error);
        } finally {
          setLoading(false);
        }
      } catch (err) {
        console.error("Error fetching propertyId/referrerId:", err);
        setLoading(false);
      }
    };
 
    runEffect();
  }, [projectId, referralCode, isAuthenticated, userId, dispatch]);
 
  const layoutConfig = [
    {
      id: "ProjectLayoutPage",
      render: () => <ProjectLayoutPage data={projectData} type={type} />,
    },
    {
      id: "ProjectPlotStructure",
      render: () => <ProjectPlotStructure data={projectData} type={type} isAuthenticated={isAuthenticated} />,
    },
    {
      id: "ProjectDescription",
      render: () => <Description data={projectData} />,
    },
    {
      id: "ProjectImages",
      render: () => <ProjectImages data={projectData} />
    },
    {
      id: "RecentProjects",
      render: () => <RecentPropertiesList userId={userId} type={1} propertyId={projectData.id} />
    },
    // {
    //   id: "ProjectDocument",
    //   render: () => <ProjectDocument data={projectData.id} type={projectData.type} userId={userId} />
    // },
    // {
    //   id: "ProjectMap",
    //   render: () => <ProjectMap data={projectData} />
    // }
 
  ];
 
  // if (!isAuthenticated) {
  //   return (
  //     <LoginModal/>
  //   );
  // }
 
  return (
    <ScreenContainer>
      {loading ? (
        <Loader />
      ) : (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          padding: "5px"
        }}>
          {layoutConfig.map((section) => (
            <div
              key={section.id}
              style={{ backgroundColor: theme.background, ...styles.section }}
            >
              {section.render()}
            </div>
          ))}
        </Box>
      )}
    </ScreenContainer>
  );
 
};
 
const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    // padding: "10px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
 
  },
  heading: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "24px",
    color: "#333",
 
  },
  loadingText: {
    fontSize: "16px",
    color: "#555",
    textAlign: "center",
    marginTop: "40px",
 
  },
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
 
  },
 
};
 
export default ProjectDetailsScreen;